export default "__VITE_PUBLIC_ASSET__2689d15b__"